<template>
  <div
    v-if="displayItems.length"
    class="institutional-logos-banner"
    :class="variant"
  >
    <img
      v-for="(logo, index) in displayItems"
      :key="`${logo.url}-${index}`"
      :src="logo.url"
      :alt="logo.alt"
      class="institutional-logo"
    />
  </div>
</template>

<script>
import { loadSiteIdentity } from "@/helpers/site-identity/site-identity-api.js";

export default {
  name: "InstitutionalLogosBanner",
  props: {
    variant: {
      type: String,
      default: "default",
      validator: (value) => ["default", "compact"].includes(value),
    },
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      loadedItems: [],
    };
  },
  computed: {
    displayItems() {
      if (Array.isArray(this.items)) {
        return this.items.filter((item) => item?.url);
      }
      return this.loadedItems;
    },
  },
  async mounted() {
    if (!Array.isArray(this.items)) {
      const identity = await loadSiteIdentity();
      this.loadedItems = identity?.institutional_logos || [];
    }
  },
};
</script>

<style lang="scss" scoped>
.institutional-logos-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: nowrap;
  width: 100%;
  min-width: 0;

  .institutional-logo {
    height: 50px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    transition: opacity 0.3s ease;
    flex: 1 1 0;
    min-width: 0;
    max-height: 50px;

    &:hover {
      opacity: 0.8;
    }
  }

  &.compact {
    gap: 0.75rem;

    .institutional-logo {
      height: 65px;
      max-height: 65px;
    }
  }

  @media (max-width: 1200px) {
    gap: 1rem;

    .institutional-logo {
      height: 48px;
      max-height: 48px;
    }

    &.compact {
      gap: 0.75rem;

      .institutional-logo {
        height: 60px;
        max-height: 60px;
      }
    }
  }

  @media (max-width: 992px) {
    gap: 0.75rem;

    .institutional-logo {
      height: 45px;
      max-height: 45px;
    }

    &.compact {
      gap: 0.6rem;

      .institutional-logo {
        height: 55px;
        max-height: 55px;
      }
    }
  }

  @media (max-width: 768px) {
    gap: 0.5rem;

    .institutional-logo {
      height: 40px;
      max-height: 40px;
    }

    &.compact {
      gap: 0.6rem;

      .institutional-logo {
        height: 50px;
        max-height: 50px;
      }
    }
  }

  @media (max-width: 576px) {
    gap: 0.5rem;

    .institutional-logo {
      height: 40px;
      max-height: 40px;
    }

    &.compact {
      gap: 0.4rem;

      .institutional-logo {
        height: 30px;
        max-height: 30px;
      }
    }
  }

  @media (max-width: 480px) {
    gap: 0.4rem;

    .institutional-logo {
      height: 35px;
      max-height: 35px;
    }

    &.compact {
      gap: 0.3rem;

      .institutional-logo {
        height: 28px;
        max-height: 28px;
      }
    }
  }

  @media (max-width: 360px) {
    gap: 0.3rem;

    .institutional-logo {
      height: 30px;
      max-height: 30px;
    }

    &.compact {
      gap: 0.25rem;

      .institutional-logo {
        height: 25px;
        max-height: 25px;
      }
    }
  }
}
</style>
